import React from 'react'
import { SearchList } from './search-list'
import { WithSearchListProps } from './with-search-list.types'
import { virtualizedListDefaultProps } from '$common/virtualized-list'

export function WithSearchList<Item, SearchParams>({
  hasSearchQuery,
  children,
  ...other
}: WithSearchListProps<Item, SearchParams>) {
  return (
    <React.Fragment>
      {hasSearchQuery ? <SearchList {...other} /> : children}
    </React.Fragment>
  )
}

WithSearchList.defaultProps = {
  ...virtualizedListDefaultProps,
  items: undefined,
}
